import tieredPricingRules from "./../../tieredPricingRules.json";
import TieredPricingBlock from "./TieredPricingBlock";

export default function TieredPricingBlocks({attributes}) {

    const wrapperStyle = {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        margin: "15px 0",
    }

    return (
        <div style={wrapperStyle}>
            {tieredPricingRules.map(rule => {
                return <TieredPricingBlock attributes={attributes} isSelected={rule.isSelected} key={rule.quantity}
                                           quantity={rule.quantity} discount={rule.discount} price={rule.price}/>
            })}
        </div>
    )
}
